import type { TravelMode } from 'tripPlanner/api/routes/getRouteInfo'
import { roundLatLng } from './utils'

export function durationRoutesQueryKey(
  origin?: { lat: number, lng: number },
  destination?: { lat: number, lng: number },
  travelMode?: TravelMode,
) {
  return ['durationRoutes', roundLatLng(origin), roundLatLng(destination), travelMode] as const
}
